<section id="about" >
    <div class="container">


    <header class="section-header">
      <h3 class="section-title" style="text-align: center;">Lottery Management Software</h3>
    </header>
    <div class="row row-eq-height justify-content-center">
 
        <div class="row" style="margin: 20px;" >
            <img src="../assets/img/Lottery.png"  alt="" >
          </div>

        <div class="row about-container">

          
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
             
              <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Sales (Outward) Register</a></h4>
                <p class="description">Sales (Outward) entry is designed to scan your packets easily and get make calculations ready.</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Inventory Management</a></h4>
                <p class="description">Maintain Lottery Game Inventory as per Min / Max stock and see present Inventory.</p>
              </div>
  
              <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                <h4 class="title"><a href="">Accurate Lottery reports</a></h4>
                <p class="description">Allow employees to check spcific lottery reports and print Reports on 58 mm /80 mm / A4 size Paper.
                  </p>
              </div>
  
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Purchase Order Management</a></h4>
                  <p class="description">Control and track purchasing of Game packets by using Inventory reports. </p>
                </div>

                <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Game Packet History</a></h4>
                    <p class="description">You can track particular Game book and see book history</p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Owner Validation Report</a></h4>
                    <p class="description">It shows exact batch collection amount and present unsold stock and other details.
                      </p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Return Packets Entry</a></h4>
                    <p class="description">Maintain details of Return Game Packets to State and Return Register.
                      </p>
                  </div>
                
            </div>
           
  
  
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
             

              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fa fa-check-circle"></i></div>
                  <h4 class="title"><a href="">Speedy Checkout</a></h4>
                  <p class="description">Speedy Calculation of Daily Account.
                    </p>
                </div>

                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fa fa-check-circle"></i></div>
                    <h4 class="title"><a href="">Easy Inward Entry</a></h4>
                    <p class="description">Inward New Games and New Books by easy single transaction.
                      </p>
                  </div>
                  <div class="icon-box wow fadeInUp">
                      <div class="icon"><i class="fa fa-check-circle"></i></div>
                      <h4 class="title"><a href="">Batch Close report </a></h4>
                      <p class="description">Scan all Packets at Counter and Batch Collection Report will get ready. </p>
                    </div>
                    <div class="icon-box wow fadeInUp">
                        <div class="icon"><i class="fa fa-check-circle"></i></div>
                        <h4 class="title"><a href="">Ascending Order and Descending Order Sale</a></h4>
                        <p class="description">Scan tickets at counter by Ascending Order OR Descending Order.
                          </p>
                      </div>
      
                      <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Auto Email and Backup facility</a></h4>
                          <p class="description">You will get auto email after Batch close.
                            </p>
                        </div>
                       
                        <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Vending Machine Entry</a></h4>
                          <p class="description">Maintain details of Vending Machine Games and Packets used.
                            </p>
                        </div>
                        <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Correction Entry facility</a></h4>
                          <p class="description">Can do Correction Entry and see Correction Report.
                            </p>
                        </div>
                      


                        <div class="icon-box wow fadeInUp">
                          <div class="icon"><i class="fa fa-check-circle"></i></div>
                          <h4 class="title"><a href="">Employees Security Module</a></h4>
                          <p class="description">Employee can use software as per his authority.
                            </p>
                        </div>     
            </div>
          </div>
         
          <div class="row" >
            <div class="col-2" >
           
          </div>
         
            
        </div>
          
      </div>
  </div>
</section>